import * as VOXLib from 'voximplant-websdk';
import type { Call } from 'voximplant-websdk/Call/Call';

import type { IUser } from 'store/declare';

/**
 * Состояние микрофона пользователей конференции на стороне vox
 * в формате
 *
 * `{ID_ПОЛЬЗОВАТЕЛЯ: СОСТОЯНИЕ_МИКРОФОНА}`
 * */
export type MicrophoneStatus = Record<string, boolean>;

/** Установить слушатель события обновления таймера */
export function attachMicrophoneMessageReceivedEvent(voxCall: Call, updateUserList: React.Dispatch<React.SetStateAction<IUser[]>>) {
    voxCall.on(VOXLib.CallEvents.MessageReceived, ({ text }: { text: string }) => {
        const { microphoneStatus } = JSON.parse(text) as {
            microphoneStatus?: MicrophoneStatus;
        };

        // обновление состояния микрофона всех собеседников
        if (microphoneStatus !== undefined) {
            updateUserList(users => {
                return users.map(user => {
                    if (Object.keys(microphoneStatus).includes(user.id)) {
                        return {
                            ...user,
                            isMuted: !microphoneStatus[user.id],
                        };
                    }

                    return user;
                });
            });
        }
    });
}
